import { createReducer, on } from '@ngrx/store';
import { IUnidade } from 'src/app/shared/interfaces/unidade/iunidade';
import { editUnidade, editUnidadeError, editUnidadeSuccess, loadUnidade, loadUnidadeSuccess, saveUnidade, saveUnidadeError, saveUnidadeSuccess } from './unidade.actions';

export interface IUnidadeState {
  lista: IUnidade[] | any;
  isLoading: boolean,
  type: string,
  action: string,
  currentUnit: any,
  error: any


  //types: "loading" | "success" | "error"
  //actions: "save" | "get" | "edit" | "delete"
}

const initialState: IUnidadeState = {
  lista: [],
  isLoading: false,
  type: '',
  action: '',
  currentUnit: null,
  error: null
};

export const unidadeReducer = createReducer(
  initialState,
  on(loadUnidade, (state) => ({
    ...state,
    type: "loading",
    action: "get"
  })),

  on(loadUnidadeSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    type: "success",
    action: "get"
  })),

  on(saveUnidade, (state) => ({
    ...state,
    type: "loading",
    action: "save"
  })),

  on(saveUnidadeSuccess, (state, {unidade}) => ({
    ...state,
    type: "success",
    action: "save",
    currentUnit: unidade
    
  })),

  on(saveUnidadeError, (state,{error}) => ({
    ...state,
    type: "error",
    action: "save",
    error: error
  })),

  on(editUnidade, (state) => ({
    ...state,
    type: "loading",
    action: "edit"
  })),

  on(editUnidadeError, (state) => ({
    ...state,
    type: "error",
    action: "edit"
  })),

  on(editUnidadeSuccess, (state, {unidade}) => ({
    ...state,
    type: "success",
    action: "edit",
    currentUnit: unidade
  })),

  
);
